console.log('%cProudly made by ' + '%cVoice Agency', 'color: #000', 'background: #6eff6e; color: #000');
console.log('https://www.voice.be');